var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "29px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M24.973,7.893 L20.352,7.893 L20.352,3.272 C20.352,1.573 18.971,0.192 17.272,0.192 L3.411,0.192 C1.712,0.192 0.331,1.573 0.331,3.272 L0.331,10.973 C0.331,12.672 1.712,14.053 3.411,14.053 L4.951,14.053 L4.951,16.556 C4.951,16.898 5.230,17.134 5.529,17.134 C5.644,17.134 5.764,17.100 5.870,17.018 L9.571,14.924 L9.571,18.674 C9.571,20.373 10.953,21.754 12.652,21.754 L17.272,21.754 L22.513,24.719 C22.619,24.796 22.739,24.834 22.855,24.834 C23.153,24.834 23.433,24.598 23.433,24.257 L23.433,21.754 L24.973,21.754 C26.672,21.754 28.053,20.373 28.053,18.674 L28.053,10.973 C28.053,9.274 26.672,7.893 24.973,7.893 ZM4.951,11.743 L3.411,11.743 C2.987,11.743 2.641,11.397 2.641,10.973 L2.641,3.272 C2.641,2.849 2.987,2.502 3.411,2.502 L17.272,2.502 C17.696,2.502 18.042,2.849 18.042,3.272 L18.042,10.973 C18.042,11.397 17.696,11.743 17.272,11.743 L10.505,11.743 L9.976,12.042 L7.261,13.577 L7.261,11.743 L4.951,11.743 ZM25.743,18.674 C25.743,19.097 25.396,19.444 24.973,19.444 L21.122,19.444 L21.122,21.277 L18.408,19.742 L17.878,19.444 L12.652,19.444 C12.228,19.444 11.882,19.097 11.882,18.674 L11.882,14.053 L17.272,14.053 C18.971,14.053 20.352,12.672 20.352,10.973 L20.352,10.203 L24.973,10.203 C25.396,10.203 25.743,10.550 25.743,10.973 L25.743,18.674 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.eec35f94c9c22c9acdbb5fa30a7c4c31.svg";
export { ForwardRef as ReactComponent };